/**
 * Download data as a JSON file
 * @param {Object} data - The data to download
 * @param {string} filename - The filename (should include .json extension)
 */
export function downloadJson(data, filename) {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

/**
 * Strip characters illegal in filenames on Windows/macOS.
 * @param {string} s - Raw filename (without extension)
 */
export function safeFilename(s) {
  return String(s).replace(/[\/\\:*?"<>|]/g, '').trim()
}

/**
 * Download a Blob as a file
 * @param {Blob} blob - The blob to download
 * @param {string} filename - The filename
 */
export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}
